import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { FixedImage } from '@/app/donation/(home)/_components/GoodsDonationHome/FixedImage';
import { GOODS_HOME_IMAGE_URL } from '@/constants/yearEndDonationHome';

//* 시안 락업(wello! | KAKAO FRIENDS)의 간격을 높이(1em) 비율로 옮겼다 — 쓰는 곳은 font-size로 높이만 정한다
export const GoodsLockup = t0 => {
  const $ = _c(16);
  const {
    tone: t1,
    className
  } = t0;
  const tone = t1 === undefined ? "dark" : t1;
  const imageToneClassName = tone === "light" && "brightness-0 invert";
  const t2 = tone === "light" ? "text-Gray-white" : "text-Gray-black";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("relative block h-[1em] w-[11.647em] shrink-0", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== imageToneClassName) {
    t4 = cn("absolute left-0 top-0 h-[1em] w-[3.028em]", imageToneClassName);
    $[3] = imageToneClassName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <FixedImage src={GOODS_HOME_IMAGE_URL.LOCKUP_WELLO} sizes="70px" className={t4} imageClassName="object-contain" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span aria-hidden={true} className="absolute left-[3.61em] top-[0.298em] h-[0.616em] w-[1px] bg-[currentColor] opacity-40" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== imageToneClassName) {
    t7 = cn("absolute left-[4.214em] top-[0.26em] h-[0.656em] w-[7.433em]", imageToneClassName);
    $[8] = imageToneClassName;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <FixedImage src={GOODS_HOME_IMAGE_URL.LOCKUP_KAKAO_FRIENDS} sizes="171px" className={t7} imageClassName="object-contain" />;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t8) {
    t9 = <span role="img" aria-label={"\uC6F0\uB85C X \uCE74\uCE74\uC624\uD504\uB80C\uC988"} className={t3}>{t5}{t6}{t8}</span>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};